module.exports = global["jQuery"] = require("-!C:\\wamp64\\www\\easyfinance\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");